import { useEffect, useState } from "react";
import {
  Column,
  DataGrid,
  Export,
  FilterRow,
  HeaderFilter,
  Paging,
  SearchPanel,
  Selection,
} from "devextreme-react/data-grid";
import {
  actionCapitalizationList,
  actionCdRecoveryList,
  resetCapitalizationList,
  resetCdRecoveryList,
} from "../store";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import AddCapitalization from "../../../../../component/add_capitalization";
import moment from "moment";
import { useForm } from "react-hook-form";
import AddCdRecovery from "../../../../../component/cd_recovery";
import ListDateFilters from "../../../../../component/filters/list_date_filters";
import { onExporting } from "../../../../../utils";
import AddCdRecoveryEndorsement from "../../../../../component/cd_recovery_Endorsement";
import Loader from '../../../../../component/page_loader';

const TaskPanel = (props) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const receivedData = location.state?.data || null;
  const [isCapitalizationModel, setIsCapitalizationModel] = useState(false);
  const [isCdRecoveryModel, setIsCdRecoveryModel] = useState(false);
  const [isCdRecoveryEndorsementModel, setIsCdRecoveryEndorsementModel] = useState(false);
  const [selectedIds, setSelectedIds] = useState([]);
  const [cdSelectedIds, setCdSelectedIds] = useState([]);
  const [cdEndorsementSelectedIds, setCdEndorsementSelectedIds] = useState([]);
  const [selectedDetails, setSelectedDetails] = useState(null);
  const [button, setButton] = useState(receivedData ? 'pendingcd' :"allcap");
  const [activeTab, setActiveTab] = useState(receivedData ? 'cdrec' :"capitalization"); // State to track active tab
  const [isLoader, setIsLoader] = useState(true);

  const [capitalizationListAllCount, setCapitalizationListAllCount] =
    useState(null);
  const [cdRecoveryListAllCount, setCdRecoveryListAllCount] = useState(null);

  // Create const(variable) to get data in datasource of data grid
  const [capitalizationListDetails, setCapitalizationListDetails] = useState(
    []
  );
  const [cdRecoveryListDetails, setCdRecoveryListDetails] = useState([]);
  const [cdRecoveryendorsementListDetails, setCdRecoveryendorsementListDetails] = useState([]);

  // call from store for data
  const { CapitalzationList } = useSelector(state => ({
    ...state.employerStore,
  }));

  const { CdRecoveryList } = useSelector(state => ({
    ...state.employerStore,
  }));

  // END

  // START : FILTER
  // Function to update fromDate in the parent component
  const updateFromDate = newFromDate => {
    setFromDate(newFromDate);
  };
  // Function to update toDate in the parent component
  const updateToDate = newToDate => {
    setToDate(newToDate);
  };
  // Function to final fromDate in the parent component
  const finalFromDate = newFromDate => {
    fromDate(newFromDate);
  };
  // Function to final toDate in the parent component
  const finalToDate = newToDate => {
    toDate(newToDate);
  };
  // END
  // capitalization list api call (dispatch)
  useEffect(() => {
    if(receivedData){
      dispatch(
        actionCdRecoveryList({
          type: "policy",
          recovery: "notset",
          from_date: fromDate,
          to_date: toDate,
        })
      );
    }else{
      dispatch(
        actionCapitalizationList({
          from_date: fromDate,
          to_date: toDate,
        })
      );
    }
  }, []);


  //Reset function
  const handleResetClick = () => {
    setFromDate(initialFromDate); // Reset fromDate to its initial value
    setToDate(initialToDate); // Reset fromDate to its initial value
  };
  const initialFromDate = "";
  const initialToDate = "";
  // take updated date in state
  const [fromDate, setFromDate] = useState(initialFromDate);
  const [toDate, setToDate] = useState(initialToDate);

  // END

  // put data in const(variable which will get through api)
  useEffect(() => {
    if (CapitalzationList) {
      dispatch(resetCapitalizationList());
      if (CapitalzationList.status == true) {
        setIsLoader(false);
        setCapitalizationListDetails(CapitalzationList.data);
        setCapitalizationListAllCount(CapitalzationList.data.length);
      }
    }
  }, [CapitalzationList]);

  useEffect(() => {
    if (CdRecoveryList) {
      dispatch(resetCdRecoveryList());
      if (CdRecoveryList.status == true) {
        setIsLoader(false);
        setCdRecoveryListDetails(CdRecoveryList.data);
        setCdRecoveryListAllCount(CdRecoveryList.data.length);
      }
    }
  }, [CdRecoveryList]);

  // END

  //START: CELL RENDER
  // Make and Modal render cell
  const renderMakeModal = data => {
    // Access the necessary data properties from the data object
    const field1 = data?.vehicle_make; // Assuming field1 is one of the fields you want to merge
    const field2 = data?.vehicle_model; // Assuming field2 is the other field you want to merge
    // Merge the fields (example: concatenating them)
    const mergedValue = `${field1} - ${field2}`;
    // Return the merged value
    return mergedValue;
  };
  const renderMakeModalendorsement = data => {
    // Access the necessary data properties from the data object
    const field1 = data?.policyDetails?.vehicle_make; // Assuming field1 is one of the fields you want to merge
    const field2 = data?.policyDetails?.vehicle_model; // Assuming field2 is the other field you want to merge
    // Merge the fields (example: concatenating them)
    const mergedValue = `${field1} - ${field2}`;
    // Return the merged value
    return mergedValue;
  };
  const renderDateCell = date => {
    const formattedDate = moment(date).isValid()
      ? moment(date).format("DD-MMM-YYYY")
      : "-";
    return formattedDate;
  };
  const renderAmountFixed = data => {
    const amountFormat = data ? Number(data).toFixed(2) : "-";
    return amountFormat;
  };
  // END: CELL RENDER

  // EVENTS
  const handleSelectionChanged = e => {
    // Capitalization
    setSelectedIds(e.selectedRowsData.map(row => row.id));
    setSelectedDetails(e.selectedRowsData.map(row => row.gross_premium));
  };

  const handleCdRecoverySelectionChanged = e => {
    // Cd recovery
    setCdSelectedIds(e.selectedRowsData.map(row => row.id));
    setSelectedDetails(e.selectedRowsData.map(row => row.gross_premium));
  };

  const handleCdRecoveryEndorsementSelectionChanged = e => {
    // Cd recovery
    setCdEndorsementSelectedIds(e.selectedRowsData.map(row => row.id));
    setSelectedDetails(e.selectedRowsData.map(row => row.total_amount));
  };

  // Active tab onClick
  // Function to handle tab click
  const handleCdrecClick = (cdrec) => {
    setActiveTab(cdrec); // Update active tab state policy
  };
  const handleCdrecendorsementClick = (cdrecendorsement) => {
    setActiveTab(cdrecendorsement); // Update active tab state - endorsement
  };
  const handleCapitalizationClick = (capitalization) => {
    setActiveTab(capitalization); // Update active tab state
  };
  return (
    <>
      <div className="row justify-content-center mb-5 mt-6">
        <div className="col-12">
          <div className="d-flex justify-content-between mb-2">
            <div className="">
              <h5 className="mb-0">Admin Task</h5>
            </div>
          </div>
          {/* renewal date filter */}
          {/* <ListDateFilters
            lebel1={"Renewal Start Date"}
            lebel2={"Renewal End Date"}
            updateFromDate={updateFromDate}
            updateToDate={updateToDate}
            resetClick={handleResetClick}
            fromDate={fromDate}
            toDate={toDate}
          /> */}


          {/* View */}
          {isLoader === true ? (
            <Loader />
          ) : (
            <>
              <div className="mt-3 mb-2">
                <button
                  className={activeTab === "capitalization" ? "btn btn-primary ms-2" : "btn btn-light ms-2 text-dark border"}
                  id="capitalization-tab"
                  type="button"
                  onClick={() => {
                    dispatch(
                      actionCapitalizationList({ from_date: fromDate, to_date: toDate, })
                    );
                    handleCapitalizationClick("capitalization");
                    setButton("allcap");
                  }}
                >
                  Capitalization
                </button>
                <button
                  className={activeTab === "cdrec" ? "btn btn-primary ms-2" : "btn btn-light ms-2 text-dark border"}
                  id="cdrec-tab"
                  type="button"
                  onClick={() => {
                    dispatch(
                      actionCdRecoveryList({ from_date: fromDate, to_date: toDate, type: "policy" })
                    );
                    handleCdrecClick("cdrec");
                    setButton("allcd");
                  }}
                >
                  CD Recovery - Policy
                </button>
                <button
                  className={activeTab === "cdrecendorsement" ? "btn btn-primary ms-2" : "btn btn-light ms-2 text-dark border"}
                  id="cdrec-endorsement-tab"
                  type="button"
                  onClick={() => {
                    dispatch(
                      actionCdRecoveryList({ from_date: fromDate, to_date: toDate, type: "endorsement" })
                    );
                    handleCdrecendorsementClick("cdrecendorsement");
                    setButton("allcd");
                  }}
                >
                  CD Recovery - Endorsement
                </button>
              </div>
              <div class="tab-content mt-3" id="myTabContent">
                {/* ---------------------------------Capitalization Tab ------------------------------- */}
                {activeTab === "capitalization" && (
                  <>
                    <div
                      class=""
                      id="capitalization"
                      aria-labelledby="capitalization-tab"
                    >
                      <div className="card mb-5">
                        <div className="card-header d-flex justify-content-end">
                          <div className="col-6 my-auto fw-600 text-end">
                            <button
                              className="btn btn-primary2 me-2"
                              onClick={() => {
                                setButton("allcap");
                                dispatch(actionCapitalizationList());
                              }}
                            >
                              All
                              {button === "allcap" && (
                                <span>({capitalizationListAllCount})</span>
                              )}
                            </button>
                            <button
                              className="btn btn-primary2"
                              onClick={() => {
                                setButton("pendingcap");
                                dispatch(
                                  actionCapitalizationList({
                                    type: "notset",
                                    from_date: fromDate,
                                    to_date: toDate,
                                  })
                                );
                              }}
                            >
                              Pending
                              {button === "pendingcap" && (
                                <span>({capitalizationListAllCount})</span>
                              )}
                            </button>
                          </div>
                        </div>
                        <div className="card-body">
                          <div id="capitalization-container">
                            <DataGrid
                              // id="task_pannel_list"
                              dataSource={capitalizationListDetails}
                              onSelectionChanged={handleSelectionChanged}
                              showBorders={true}
                              keyExpr="id"
                              columnAutoWidth={true}
                              columnMinWidth={100}
                              filterSyncEnabled={false}
                              allowColumnResizing={true}
                              onExporting={onExporting}
                            >
                              <HeaderFilter visible={true} />
                              <SearchPanel visible={true} />
                              <Selection
                                mode="multiple"
                                showCheckBoxesMode="always"
                              />
                              <FilterRow visible={true} />
                              <Paging defaultPageSize={10} />
                              <Column
                                dataField="index"
                                caption="S.No"
                                dataType="number"
                                cellRender={rowData => {
                                  return rowData?.rowIndex != null
                                    ? Number(rowData?.rowIndex + 1)
                                    : "-";
                                }}
                              />
                              <Column
                                dataField="userDetails.full_name"
                                caption="Emp Name"
                              />
                              <Column
                                dataField="userDetails.mobile"
                                caption="Emp Mobile No."
                                dataType="string"
                              />
                              <Column
                                dataField="userDetails.userCity.name"
                                caption="Emp City"
                              />
                              <Column
                                dataField="userDetails.userCity.cityState.stateZone.name"
                                caption="Emp Zone"
                              />
                              <Column
                                dataField="vehicle_no"
                                caption="Vehicle Registration No."
                              />
                              <Column
                                dataField="vehicle_make_model"
                                caption="Vehicle Make & Model"
                                cellRender={({ data }) => renderMakeModal(data)}
                              />
                              <Column
                                dataField="capitalization_date"
                                caption="Capitalization Date"
                                dataType="date"
                                cellRender={({ value }) => renderDateCell(value)}
                              // visible={button === "capitalization" ? true : false}
                              />
                              <Column
                                dataField="policy_expiry_date"
                                caption="Policy End Date"
                                dataType="date"
                                cellRender={({ value }) => renderDateCell(value)}
                              />
                              <Export enabled={true} />
                            </DataGrid>
                          </div>
                        </div>
                        <div className="card-footer text-center">
                          <button
                            type="button"
                            class="btn btn-primary"
                            data-bs-toggle="modal"
                            data-bs-target="#capitalization"
                            disabled={selectedIds?.length ? false : true}
                            onClick={() => {
                              setIsCapitalizationModel(true);
                            }}
                          >
                            Update
                          </button>
                        </div>
                      </div>
                    </div>
                  </>
                )}
                {/* ---------------------------------CD Recovery Tab -------------------------------------- */}
                {activeTab === "cdrec" && (
                  <>
                    <div
                      class=""
                      id="cdrec-policy"
                      aria-labelledby="cdrec-policy-tab"
                    >
                      <div className="card mb-5">
                        <div className="card-header d-flex justify-content-end">
                          <div className="col-6 my-auto fw-600 text-end">
                            <button
                              className="btn btn-primary2 me-2"
                              onClick={() => {
                                setButton("allcd");
                                dispatch(actionCdRecoveryList({ type: "policy" }));
                              }}
                            >
                              All{" "}
                              {button === "allcd" && (
                                <span>({cdRecoveryListAllCount})</span>
                              )}
                            </button>
                            <button
                              className="btn btn-primary2"
                              onClick={() => {
                                setButton("pendingcd");
                                dispatch(
                                  actionCdRecoveryList({
                                    type: "policy",
                                    recovery: "notset",
                                    from_date: fromDate,
                                    to_date: toDate,
                                  })
                                );
                              }}
                            >
                              Pending
                              {button === "pendingcd" && (
                                <span>({cdRecoveryListAllCount})</span>
                              )}
                            </button>
                          </div>
                        </div>
                        <div className="card-body">
                          <DataGrid
                            id="cd_recovery_task_pannel_list"
                            dataSource={cdRecoveryListDetails}
                            onSelectionChanged={handleCdRecoverySelectionChanged}
                            columnMinWidth={100}
                            showBorders={true}
                            filterSyncEnabled={false}
                            allowColumnResizing={true}
                            columnAutoWidth={true}
                            // keyExpr="id"
                            onExporting={onExporting}
                          >
                            <HeaderFilter visible={true} />
                            <SearchPanel visible={true} />
                            <Selection
                              mode="multiple"
                              showCheckBoxesMode="always"
                            />
                            <FilterRow visible={true} />
                            <Paging defaultPageSize={10} />
                            <Column
                              dataField="index"
                              caption="S.No"
                              dataType="number"
                              cellRender={rowData => {
                                return rowData?.rowIndex != null
                                  ? Number(rowData?.rowIndex + 1)
                                  : "-";
                              }}
                            />
                            <Column
                              dataField="userDetails.full_name"
                              caption="Employee Name"
                            />
                            <Column
                              dataField="userDetails.mobile"
                              caption="Employee Mobile Number"
                              dataType="string"
                            />
                            <Column
                              dataField="userDetails.userCity.name"
                              caption="Emp City"
                            />
                            <Column
                              dataField="userDetails.userCity.cityState.stateZone.name"
                              caption="Emp Zone"
                              width={50}
                            />
                            <Column
                              dataField="vehicle_no"
                              caption="Vehicle Registration Number"
                            />
                            <Column
                              dataField="vehicle_make_model"
                              caption="Vehicle Make & Model"
                              cellRender={({ data }) => renderMakeModal(data)}
                            />

                            <Column
                              dataField="gross_premium"
                              caption="Policy Total Premium"
                              dataType="number"
                              cellRender={({ value }) => renderAmountFixed(value)}
                            />
                            <Column
                              dataField="endorsements_premium_sum"
                              caption="Endorsement Premium"
                              dataType="number"
                              cellRender={({ value }) => renderAmountFixed(value)}
                            />
                            <Column
                              dataField="recovery_status"
                              caption="CD Recovery Status"
                              cellRender={({ data }) =>
                                data.recovery_date ? "Yes" : "No"
                              }
                            />
                            <Column
                              dataField="cd_recovery_amount"
                              caption="CD Recovery Amount"
                              dataType="number"
                              cellRender={({ value }) => renderAmountFixed(value)}
                            />
                            <Column
                              dataField="cd_recovery_date"
                              caption="Recovery Date"
                              dataType="date"
                              cellRender={({ value }) => renderDateCell(value)}
                            />
                            <Column dataField="policy_no" caption="Policy Number" />

                            <Column
                              dataField="net_premium"
                              caption="Policy Net Premium"
                              dataType="number"
                              cellRender={({ value }) => renderAmountFixed(value)}
                            />
                            <Column
                              dataField="insurer_name"
                              caption="Insurer Name"
                            />
                            <Column
                              dataField="policy_expiry_date"
                              caption="Policy End Date"
                              dataType="date"
                              cellRender={({ value }) => renderDateCell(value)}
                            />
                            <Export enabled={true} />
                          </DataGrid>
                        </div>
                        <div className="card-footer text-center">
                          <button
                            type="button"
                            class="btn btn-primary"
                            data-bs-toggle="modal"
                            disabled={cdSelectedIds?.length ? false : true}
                            data-bs-target="#cd_recovery"
                            onClick={() => {
                              setIsCdRecoveryModel(true);
                            }}
                          >
                            Update
                          </button>
                        </div>
                      </div>
                    </div>
                  </>
                )}

                {/* ---------------------------------CD Recovery Tab - endorsement -------------------------------------- */}
                {activeTab === "cdrecendorsement" && (
                  <>
                    <div
                      class=""
                      id="cdrec-endorsement"
                      aria-labelledby="cdrec-endorsement-tab"
                    >
                      <div className="card mb-5">
                        <div className="card-header d-flex justify-content-end">
                          <div className="col-6 my-auto fw-600 text-end">
                            <button
                              className="btn btn-primary2 me-2"
                              onClick={() => {
                                setButton("allcd");
                                dispatch(actionCdRecoveryList({ type: "endorsement" }));
                              }}
                            >
                              All{" "}
                              {button === "allcd" && (
                                <span>({cdRecoveryListAllCount})</span>
                              )}
                            </button>
                            <button
                              className="btn btn-primary2"
                              onClick={() => {
                                setButton("pendingcd");
                                dispatch(
                                  actionCdRecoveryList({
                                    type: "endorsement",
                                    recovery: "notset",
                                    from_date: fromDate,
                                    to_date: toDate,
                                  })
                                );
                              }}
                            >
                              Pending{" "}
                              {button === "pendingcd" && (
                                <span>({cdRecoveryListAllCount})</span>
                              )}
                            </button>
                          </div>
                        </div>
                        <div className="card-body">
                          <DataGrid
                            id="cd_recovery_task_pannel_list"
                            dataSource={cdRecoveryListDetails}
                            onSelectionChanged={handleCdRecoveryEndorsementSelectionChanged}
                            columnMinWidth={100}
                            showBorders={true}
                            filterSyncEnabled={false}
                            allowColumnResizing={true}
                            columnAutoWidth={true}
                            // keyExpr="id"
                            onExporting={onExporting}
                          >
                            <HeaderFilter visible={true} />
                            <SearchPanel visible={true} />
                            <Selection
                              mode="multiple"
                              showCheckBoxesMode="always"
                            />
                            <FilterRow visible={true} />
                            <Paging defaultPageSize={10} />
                            <Column
                              dataField="index"
                              caption="S.No"
                              dataType="number"
                              cellRender={rowData => {
                                return rowData?.rowIndex != null
                                  ? Number(rowData?.rowIndex + 1)
                                  : "-";
                              }}
                            />
                            <Column
                              dataField="policyDetails.userDetails.full_name"
                              caption="Employee Name"
                            />
                            <Column
                              dataField="policyDetails.userDetails.mobile"
                              caption="Employee Mobile Number"
                              dataType="string"
                            />
                            <Column
                              dataField="policyDetails.userDetails.userCity.name"
                              caption="Emp City"
                            />
                            <Column
                              dataField="policyDetails.userDetails.userCity.cityState.stateZone.name"
                              caption="Emp Zone"
                              width={50}
                            />
                            <Column
                              dataField="policyDetails.vehicle_no"
                              caption="Vehicle Registration Number"
                            />
                            <Column
                              dataField="policyDetails.vehicle_make_model"
                              caption="Vehicle Make & Model"
                              cellRender={({ data }) => renderMakeModalendorsement(data)}
                            />

                            <Column
                              dataField="policyDetails.gross_premium"
                              caption="Policy Total Premium"
                              dataType="number"
                              cellRender={({ value }) => renderAmountFixed(value)}
                            />
                            <Column
                              dataField="total_amount"
                              caption="Endorsement Premium"
                              dataType="number"
                              cellRender={({ value }) => renderAmountFixed(value)}
                            />
                            <Column
                              dataField="policyDetails.recovery_status"
                              caption="CD Recovery Status"
                              cellRender={({ data }) =>
                                data.recovery_date ? "Yes" : "No"
                              }
                            />
                            <Column
                              dataField="cd_recovery_amount"
                              caption="CD Recovery Amount"
                              dataType="number"
                              cellRender={({ value }) => renderAmountFixed(value)}
                            />
                            <Column
                              dataField="cd_recovery_date"
                              caption="Recovery Date"
                              dataType="date"
                              cellRender={({ value }) => renderDateCell(value)}
                            />
                            <Column dataField="policyDetails.policy_no" caption="Policy Number" />

                            <Column
                              dataField="policyDetails.net_premium"
                              caption="Policy Net Premium"
                              dataType="number"
                              cellRender={({ value }) => renderAmountFixed(value)}
                            />
                            <Column
                              dataField="policyDetails.insurer_name"
                              caption="Insurer Name"
                            />
                            <Column
                              dataField="status"
                              caption="Status"
                            />
                            <Column
                              dataField="policyDetails.policy_expiry_date"
                              caption="Policy End Date"
                              dataType="date"
                              cellRender={({ value }) => renderDateCell(value)}
                            />
                            <Export enabled={true} />
                          </DataGrid>
                        </div>
                        <div className="card-footer text-center">
                          <button
                            type="button"
                            class="btn btn-primary"
                            data-bs-toggle="modal"
                            disabled={cdEndorsementSelectedIds?.length ? false : true}
                            data-bs-target="#cd_recovery_endorsement"
                            onClick={() => {
                              setIsCdRecoveryEndorsementModel(true);
                            }}
                          >
                            Update
                          </button>
                        </div>
                      </div>
                    </div>
                  </>
                )}

              </div>
            </>
          )}
        </div>

      </div>

      {/* Model Component */}

      <AddCdRecoveryEndorsement
        cdEndorsementSelectedIds={cdEndorsementSelectedIds}
        selectedDetails={selectedDetails}
        isCdRecoveryEndorsementModel={isCdRecoveryEndorsementModel}
        handleCdClose={() => {
          setIsCdRecoveryEndorsementModel(false);
          navigate("/employer/task-panel");
        }}
      />

      <AddCdRecovery
        cdSelectedIds={cdSelectedIds}
        selectedDetails={selectedDetails}
        isCdRecoveryModel={isCdRecoveryModel}
        handleCdClose={() => {
          setIsCdRecoveryModel(false);
          navigate("/employer/task-panel");
        }}
      />

      <AddCapitalization
        selectedIds={selectedIds}
        selectedDetails={selectedDetails}
        isCapitalizationModel={isCapitalizationModel}
        handleCapClose={() => {
          setIsCapitalizationModel(false);
          navigate("/employer/task-panel");
        }}
      />
    </>
  );
};

export default TaskPanel;
